module.exports = __webpack_public_path__ + "img/employ_3.770829a2.png";